import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
var _createReducer;
import { createReducer } from 'redux-act';
import { resource, setLastAskedCountry } from './actions';
export var initialState = {
  lastAskedCountry: undefined,
  countries: []
};
export var fetchListSuccessHandler = function fetchListSuccessHandler(state, _ref) {
  var response = _ref.response;
  return _objectSpread(_objectSpread({}, state), {}, {
    countries: response.data
  });
};
export var setLastAskedCountryHandler = function setLastAskedCountryHandler(state, alpha2) {
  return _objectSpread(_objectSpread({}, state), {}, {
    lastAskedCountry: alpha2
  });
};
export var fetchOneSuccessHandler = function fetchOneSuccessHandler(state, _ref2) {
  var response = _ref2.response,
    label = _ref2.label;
  var data = response.data;
  return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, label, _objectSpread({}, data)));
};
var reducer = createReducer((_createReducer = {}, _defineProperty(_createReducer, setLastAskedCountry.getType(), setLastAskedCountryHandler), _defineProperty(_createReducer, resource.fetch.success.getType(), fetchListSuccessHandler), _defineProperty(_createReducer, resource.fetchOne.success.getType(), fetchOneSuccessHandler), _createReducer), initialState);
export default reducer;